import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { EmployeeService } from '../../services/employees.service';
import { OrderService } from '../../services/order.service';
import { SearchOrderStop, SearchReferenceNumber } from '../../models/models';

@Component({
    selector: 'order-stop-card',
    templateUrl: './order-stop-card.component.html',
    standalone: false
})
export class OrderStopCard implements OnChanges, OnInit {
    @Input() orderNumber: string = "";
    @Input() quoteOrderID: number = 0;
    //@Input() orderStops: OrderStop[] = [];
    @Input() isCustomer: boolean = false;
    @Input() isDisplayEventDescription: boolean = false;
    @Input() cardSize: number = 12;
    @Output() onClick = new EventEmitter<any>();

    public orderStops: SearchOrderStop[] = [];
    public referenceNumbers: SearchReferenceNumber[] = [];

    constructor(private employeeService: EmployeeService, private orderService: OrderService) {
    }

    ngOnInit() {
    }

    ngOnChanges() {
        this.getStops();
        this.getReferenceNumbers();
    }

    private getStops() {
        console.log(this.quoteOrderID);
        this.orderService.getSearchOrderStopsByQuoteOrderID(this.quoteOrderID).subscribe(result => {
            this.orderStops = result.resultCollection;
            this.setupStopData();
        });
    }

    private getReferenceNumbers() {
        console.log(this.quoteOrderID);
        this.orderService.getSearchReferenceNumbersStopsByQuoteOrderID(this.quoteOrderID).subscribe(result => {
            this.referenceNumbers = result.resultCollection;
            console.log(this.quoteOrderID, result);
        });
    }

    public getIconTitle(stop: SearchOrderStop) {
        var title = "";
        if (stop.arrivedInd == true && stop.departedInd == true) {
            title = "Complete";
        }
        else if (this.isCurrentStop(stop)) {
            title = "Current";
        }
        else if (stop.arrivedInd != true || stop.departedInd != true) {
            title = "Future";
        }
        return title;
    }

    public getStopRefNumbers(orderStopID: number): SearchReferenceNumber[] {
        var refNums = this.referenceNumbers.filter(r => r.referenceTableID == orderStopID);
        return refNums;
    }

    private setupStopData() {
        this.orderStops.forEach(s => {
            s.earliestDate = new Date(s.earliestDate);
            s.latestDate = new Date(s.latestDate);
            s.arrivalDate = new Date(s.arrivalDate);
            s.departDate = new Date(s.departDate);
        });
    }

    public isCurrentStop(stop: SearchOrderStop) {
        var isCurrent = false;
        for (var i = 0; i < this.orderStops.length; i++) {
            if (this.orderStops[i].orderStopID == stop.orderStopID) {
                if (i == 0 && this.orderStops[i].arrivedInd != true && this.orderStops[i].departedInd != true) {
                    isCurrent = true;
                }
                else if (this.orderStops[i].arrivedInd == true && this.orderStops[i].departedInd != true) {
                    isCurrent = true;
                }
                else if (this.orderStops[i].arrivedInd != true && this.orderStops[i].departedInd != true && this.orderStops[i - 1].departedInd == true) {
                    isCurrent = true;
                }
            }
        }
        return isCurrent;
    }

    public stopClick(stop: SearchOrderStop) {
        this.onClick.emit(stop);
        //console.log(stop);
    }
}
